export enum WorkflowCreateMethodTypes {
    USE_TEMPLATE = "USE_TEMPLATE",
    USE_IMPORT = "USE_IMPORT",
    USE_COPY = "USE_COPY"
}